module.exports = __webpack_public_path__ + "static/media/tumblr.f6dd574d.svg";